import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, HeadphonesIcon, CheckSquareIcon, CheckIcon, GiftIcon } from 'lucide-react';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 12
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-40px'
  },
  transition: {
    duration: 0.3
  }
};
export function OfferSection() {
  return <section className="w-full bg-[#1a0b3b] py-16 md:py-24 px-5" data-id="element-236">
      <div className="max-w-5xl mx-auto" data-id="element-237">
        <motion.div {...fadeIn} className="max-w-3xl mx-auto" data-id="element-238">
          <p className="text-amber-500 text-sm font-medium tracking-wide uppercase mb-4" data-id="element-239">
            Lo que recibes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-240">
            Hábitos Atómicos Espirituales — Super Pack
          </h2>
          <p className="text-lg text-gray-300 mb-12" data-id="element-241">
            Todo lo que necesitas para impulsar tu crecimiento personal,
            financiero y espiritual en un solo paquete.
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-6 mb-20" data-id="element-242">
          {/* Ebook */}
          <motion.div {...fadeIn} transition={{
          duration: 0.3,
          delay: 0.04
        }} data-id="element-243">
            <div className="bg-white/[0.02] border border-white/5 rounded-xl p-6 md:p-8" data-id="element-244">
              <div className="flex items-center gap-3 mb-5" data-id="element-245">
                <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center" data-id="element-246">
                  <BookOpenIcon className="w-5 h-5 text-amber-500" data-id="element-247" />
                </div>
                <div data-id="element-248">
                  <h3 className="text-white font-bold text-lg" data-id="element-249">
                    Ebook — Guía Principal
                  </h3>
                  <p className="text-gray-500 text-sm" data-id="element-250">
                    Formato digital · Descarga inmediata
                  </p>
                </div>
              </div>
              <ul className="space-y-3" data-id="element-251">
                <OfferBullet text="Estrategias de productividad y crecimiento" data-id="element-252" />
                <OfferBullet text="Guía de gestión financiera personal" data-id="element-253" />
                <OfferBullet text="Plan de 30 días estructurado" data-id="element-254" />
                <OfferBullet text="Ejercicios prácticos aplicables" data-id="element-255" />
                <OfferBullet text="Protocolo de reinicio" data-id="element-256" />
              </ul>
            </div>
          </motion.div>

          {/* Audiolibro */}
          <motion.div {...fadeIn} transition={{
          duration: 0.3,
          delay: 0.06
        }} data-id="element-257">
            <div className="bg-white/[0.02] border border-white/5 rounded-xl p-6 md:p-8" data-id="element-258">
              <div className="flex items-center gap-3 mb-5" data-id="element-259">
                <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center" data-id="element-260">
                  <HeadphonesIcon className="w-5 h-5 text-amber-500" data-id="element-261" />
                </div>
                <div data-id="element-262">
                  <h3 className="text-white font-bold text-lg" data-id="element-263">Audiolibro</h3>
                  <p className="text-gray-500 text-sm" data-id="element-264">
                    Para sostenerte cuando no tienes energía
                  </p>
                </div>
              </div>
              <ul className="space-y-3" data-id="element-265">
                <OfferBullet text="Ideal para manejar, caminar, antes de dormir" data-id="element-266" />
                <OfferBullet text="Refuerza identidad y ejecución simple" data-id="element-267" />
                <OfferBullet text="Escúchalo las veces que necesites" data-id="element-268" />
              </ul>
            </div>
          </motion.div>

          {/* Habit Tracker */}
          <motion.div {...fadeIn} transition={{
          duration: 0.3,
          delay: 0.08
        }} data-id="element-269">
            <div className="bg-white/[0.02] border border-white/5 rounded-xl p-6 md:p-8" data-id="element-270">
              <div className="flex items-center gap-3 mb-5" data-id="element-271">
                <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center" data-id="element-272">
                  <CheckSquareIcon className="w-5 h-5 text-amber-500" data-id="element-273" />
                </div>
                <div data-id="element-274">
                  <h3 className="text-white font-bold text-lg" data-id="element-275">
                    Habit Tracker
                  </h3>
                  <p className="text-gray-500 text-sm" data-id="element-276">Imprimible + Digital</p>
                </div>
              </div>
              <ul className="space-y-3" data-id="element-277">
                <OfferBullet text="Mide sin culpa" data-id="element-278" />
                <OfferBullet text='Ve tu consistencia real — convierte "intento" en "cumplo"' data-id="element-279" />
                <OfferBullet text="Diseñado para el método ANCLA" data-id="element-280" />
              </ul>
            </div>
          </motion.div>
        </div>

        {/* 5 Bonuses Section */}
        <motion.div {...fadeIn} transition={{
        duration: 0.3,
        delay: 0.1
      }} className="mt-12" data-id="element-281">
          <div className="flex items-center gap-3 mb-10 justify-center" data-id="element-282">
            <div className="w-12 h-12 rounded-xl bg-amber-500/15 border border-amber-500/25 flex items-center justify-center" data-id="element-283">
              <GiftIcon className="w-6 h-6 text-amber-400" data-id="element-284" />
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-white" data-id="element-285">
              🎁 5 Bonos Exclusivos Incluidos
            </h3>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-286">
            <BonusCard number={1} image="https://cdn.magicpatterns.com/uploads/1DH7UxJKgWrvMCWK7TTTm5/Frases_de_poder.png" name="Frases de Poder" description="Afirmaciones diarias para reprogramar tu mentalidad" data-id="element-287" />
            <BonusCard number={2} image="https://cdn.magicpatterns.com/uploads/cihd6d6aYnrFgaV5UdQVLq/habit_tracker.png" name="Habit Tracker" description="Plantilla imprimible + digital para medir tu progreso" data-id="element-288" />
            <BonusCard number={3} image="https://cdn.magicpatterns.com/uploads/tgKSf2XWERd2yyezkfr7vx/BONO_1_Habtios_atomicos_espirituales.png" name="Reinicio Express" description="7 guiones para volver al camino en 3 minutos" data-id="element-289" />
            <BonusCard number={4} image="https://cdn.magicpatterns.com/uploads/8iMcTSAzhEPx5iySp3c6Fz/BONO_2_habitos_atomicos_espirituales.png" name="Biblioteca de Señales" description="21 disparadores para activar tus hábitos automáticamente" data-id="element-290" />
            <BonusCard number={5} image="https://cdn.magicpatterns.com/uploads/thqpSQvi2mpWEbw8ds3GSc/BONO_3_Habitos_atomicos.png" name="Plan Anti-Abandono" description="Semana Cero: 14 días de arranque imparable" data-id="element-291" />
          </div>
        </motion.div>
      </div>

      <div className="section-divider mt-16 md:mt-24" aria-hidden="true" data-id="element-292" />
    </section>;
}
function OfferBullet({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-3" data-id="element-293">
      <CheckIcon className="w-4 h-4 text-amber-500 mt-1 flex-shrink-0" data-id="element-294" />
      <span className="text-gray-300 text-sm leading-relaxed" data-id="element-295">{text}</span>
    </li>;
}
function BonusCard({
  number,
  image,
  name,
  description
}: {
  number: number;
  image: string;
  name: string;
  description: string;
}) {
  return <div className="group flex flex-col bg-white/[0.03] border border-amber-500/10 rounded-2xl overflow-hidden hover:border-amber-500/30 transition-colors" data-id="element-296">
      <div className="relative h-48 bg-[#0f0529]/50 p-4 flex items-center justify-center overflow-hidden" data-id="element-297">
        <div className="absolute top-3 left-3 w-8 h-8 rounded-full bg-amber-500/90 flex items-center justify-center z-10 shadow-lg" data-id="element-298">
          <span className="text-black font-bold text-sm" data-id="element-299">#{number}</span>
        </div>
        <img src={image} alt={name} className="w-full h-full object-contain drop-shadow-xl group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-300" />
      </div>
      <div className="p-5 flex-1 flex flex-col" data-id="element-301">
        <h4 className="text-white font-bold text-lg mb-2" data-id="element-302">{name}</h4>
        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-303">{description}</p>
      </div>
    </div>;
}